import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const BreadcrumbContainer = styled.div`
  display: flex;
  margin: 15px 0;
`
export const BreadcrumbItem = styled.div`
  margin-right: 15px;
`

export const BreadcrumbLink = styled(Link)`
  color: ${({ theme }) => theme.colors.fontSecondary};
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }
`
